export const bfiLogo = `${window.location.origin}/images/header-logo.png`; // eslint-disable-line
